import { z } from 'zod'
import { AssigneeTypeEnum } from '@omnea-app/packages/universal/users-and-groups/assigneeType'

export const AssigneeEntitySchema = z.object({
  type: z.enum(AssigneeTypeEnum),
  value: z.string(),
  id: z.string(),
  name: z.string().optional(),
  email: z.string().optional(),
  title: z.string().optional().nullable(),
  isOutOfOffice: z.boolean().optional(),
  isArchived: z.boolean().optional(),
})

export type AssigneeEntity = z.infer<typeof AssigneeEntitySchema>
